import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { ROUTES } from './horizontal-routes.config';
import { SidebarService } from "./../sidebar/sidebar.service";
import * as $ from 'jquery';
import 'metismenu';
// declare var $: any; // Import jQuery
// declare var $: any;


@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss']
})
export class HorizontalMenuComponent implements AfterViewInit {

  
  public menuItems: any[]; 
  public isCollapsed = false;

  @ViewChild('menuref',{static:true}) menuref?: ElementRef;

  constructor( public sidebarservice: SidebarService,private router: Router) {

    router.events.subscribe( (event: Event) => {

        if (event instanceof NavigationStart) {
            // Show loading indicator
        }

        if (event instanceof NavigationEnd && $(window).width() < 1025 && ( document.readyState == 'complete' || false ) ) {

            this.toggleSidebar();
            // Hide loading indicator
           
        }

        if (event instanceof NavigationError) {
            // Hide loading indicator

            // Present error to user
            // console.log(event.error);
        }
    });

}
ngOnInit() {

  // $.getScript('./assets/js/metisMenu.min.js');
  // metismenu
$(function () {
  $('#menu').metisMenu();
  $(".mobile-toggle-menu").on("click", function () {
    $(".wrapper").addClass("toggled");
  });
  // toggle menu button
  $(".toggle-icon").click(function () {
    if ($(".wrapper").hasClass("toggled")) {
      // unpin sidebar when hovered
      $(".wrapper").removeClass("toggled");
      $(".sidebar-wrapper").unbind("hover");
    } else {
      $(".wrapper").addClass("toggled");
      $(".sidebar-wrapper").hover(function () {
        $(".wrapper").addClass("sidebar-hovered");
      }, function () {
        $(".wrapper").removeClass("sidebar-hovered");
      })
    }
  });
});
this.menuItems = ROUTES.filter(menuItem => menuItem);

}

     
toggleSidebar() {
  this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());

}

getSideBarState() {
  return this.sidebarservice.getSidebarState();
}

  ngAfterViewInit() {



  }

}
